import FocusWithinExample from "./examples/FocusWithin.Example";

export default [
    {
        title: "FocusWithin example",
        component: FocusWithinExample,
        code: require("!raw-loader!./examples/FocusWithin.Example.tsx")
    }
];
